import { type CostClassificationType, type InputMaybe, type Stage } from "src/generated/graphqlTypes";
import {
  type BudgetPage_ProjectItemFragment,
  type BudgetSummaryQueryResult,
} from "src/routes/projects/budget/BudgetPage.generated";
import { isDefined } from "src/utils";

export type BudgetProjectItemsFilter = {
  costCode?: InputMaybe<string[]>;
  costClassification?: InputMaybe<string[]> | null;
  stage?: Stage;
};

export function filterProjectItems(
  data: Exclude<BudgetSummaryQueryResult["data"], undefined>,
  filter: BudgetProjectItemsFilter | undefined,
): BudgetPage_ProjectItemFragment[] {
  return data.project.stages
    .filter((s) => s.hasSignedContract)
    .filter((s) => !filter?.stage || filter.stage === s.stage.code)
    .flatMap((s) => s.projectItems)
    .filter((pi) => {
      if (!filter?.costClassification && !filter?.costCode) return pi;
      return Object.entries(filter).every(([k, v]) =>
        k === "costClassification" && isDefined(v)
          ? v.includes(pi.item.costCode[k]?.code as CostClassificationType)
          : k === "costCode" && isDefined(v)
            ? v.includes(pi.item[k].id)
            : pi,
      );
    })
    .uniqueByKey("id");
}
